import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import { BottomCardComponent } from './bottom-card.component';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [BottomCardComponent],
  exports: [BottomCardComponent]
})
export class BottomCardModule {
}
